import { render, staticRenderFns } from "./SurgeWarnings.vue?vue&type=template&id=67dac8f6"
import script from "./SurgeWarnings.vue?vue&type=script&lang=js"
export * from "./SurgeWarnings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports